



























































import CountWidget from "@/components/CountWidget.vue";
import PageBody from "@/components/PageBody.vue";
import PageHeader from "@/components/PageHeader.vue";
import TableWidget from "@/components/TableWidget.vue";
import { Component, Mixins } from "vue-property-decorator";
import { DashboardHttp } from "@/mixins/http/dashboard";
// eslint-disable-next-line no-unused-vars
import { DashboardCountsData } from "@/types/dashboard";
// eslint-disable-next-line no-unused-vars
import { AxiosResponse } from "axios";
import { DomainHttp } from "@/mixins/http/domain";
// eslint-disable-next-line no-unused-vars
import { Domain } from "@/types/domain";
import { toDomain } from "@/utils";
import { HttpErrorHandler } from "@/mixins/error-handling";
import dayjs from "dayjs";
import DateUtils from "@/utils/dayjs";

@Component({
	components: {
		"page-header": PageHeader,
		"page-body": PageBody,
		"count-widget": CountWidget,
		"table-widget": TableWidget,
	},
})
export default class Dashboard extends Mixins(
	DashboardHttp,
	DomainHttp,
	HttpErrorHandler,
	DateUtils
) {
	countsData: DashboardCountsData = {
		numberOfDomains: 0,
		numberOfGroups: 0,
	};
	domains: Array<Domain> = [];
	sslsExpiringWithinThirtyDays: Array<Domain> = [];
	expiredDomainCertificates: Array<Domain> = [];
	domainsWithErrors: Array<Domain> = [];
	loading: boolean = false;

	mounted() {
		this.loading = true;
		this.getCountWidgetData()
			.then((response: AxiosResponse<any>) => {
				this.countsData = response.data;
			})
			.catch((error: any) => this.handleTokenExpired(error))
			.finally(() => (this.loading = false));

		this.getDomains()
			.then((response: AxiosResponse<any>) => {
				response.data.forEach((apiDomain: any) => {
					let domain = toDomain(apiDomain);
					if (domain) {
						this.domains.push(domain);
					}
				});

				this.breakIntoArrays();
			})
			.catch((error: any) => this.handleTokenExpired(error.response));
	}

	breakIntoArrays(): void {
		this.domains.forEach((domain) => {
			if (this.checkIfExpiringWithinThirtyDays(domain)) {
				this.sslsExpiringWithinThirtyDays.push(domain);
			}

			if (this.checkIfCertificateExpired(domain)) {
				this.expiredDomainCertificates.push(domain);
			}

			if (this.checkIfDomainHasErrors(domain)) {
				this.domainsWithErrors.push(domain);
			}
		});
	}

	checkIfExpiringWithinThirtyDays(domain: Domain): boolean {
		let certificate = domain.sslCertificates.find((certificate) =>
			this.dateIsBetweenBounds(dayjs(certificate.expires).toDate(), 1, 30)
		);

		return certificate != null && certificate != undefined;
	}

	checkIfCertificateExpired(domain: Domain): boolean {
		let certificate = domain.sslCertificates.find((certificate) =>
			dayjs(certificate.expires!).isBefore(new Date())
		);

		return certificate != null && certificate != undefined;
	}

	checkIfDomainHasErrors(domain: Domain): boolean {
		let hasErrors: boolean = false;
		if (domain.sslCertificates) {
			console.log(domain.sslCertificates);
			domain.sslCertificates.forEach((certificate) => {
				if (certificate.errors && certificate.errors.length > 0) {
					hasErrors = true;
				}
			});
		}

		return hasErrors;
	}
}
